import { User } from '@auth0/auth0-react'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  PartySummaryDto,
  UserDto,
} from 'services/APIs/InternalAPI/internal-api.contracts'
import { UserState } from './userTypes'

const initialState: UserState = {
  profile: undefined,
  organizations: undefined,
  organizationContext: undefined,
  returnUrl: undefined,
  defaultParty: undefined,
  availablePortals: undefined,
  tenantId: undefined,
}

const userSlice = createSlice({
  name: 'newUser',
  initialState: initialState,
  reducers: {
    setUserProfile: (
      state,
      action: PayloadAction<{ userProfile: UserDto; auth0User?: User }>
    ) => {
      state.profile = {
        id:
          (action.payload.userProfile && action.payload.userProfile['id']) ||
          action.payload.auth0User?.sub ||
          state.profile?.id,
        auth0Id: action.payload.auth0User?.sub || state.profile?.id,
        email:
          action.payload.userProfile?.email ||
          action.payload.auth0User?.email ||
          state.profile?.email,
        firstName:
          action.payload.userProfile?.firstName ||
          action.payload.auth0User?.given_name ||
          state.profile?.firstName,
        lastName:
          action.payload.userProfile?.lastName ||
          action.payload.auth0User?.family_name ||
          state.profile?.lastName,
        company: action.payload.userProfile?.company,
        picture:
          action.payload.userProfile?.picture ||
          action.payload.auth0User?.picture ||
          state.profile?.picture,
      }

      state.organizations = action.payload.userProfile.partiesDto
      state.availablePortals = action.payload.userProfile.availablePortals
    },
    setOrganizationContext: (state, action: PayloadAction<PartySummaryDto>) => {
      state.organizationContext = action.payload
    },
    setOrganizationContextById: (state, action: PayloadAction<string>) => {
      state.organizationContext = state.organizations?.find(
        (org) => org.id === action.payload
      )
    },
    clearOrganizationContext: (state) => {
      state.organizationContext = undefined
    },
    setTenantId: (state, action: PayloadAction<string>) => {
      state.tenantId = action.payload
    },
  },
})

export default userSlice.reducer
export const newUserActions = userSlice.actions
